import React, { useEffect, useCallback, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../../../Components/Header/Header";
import MetaData from "../../../../Components/MetaData";
import MuiDataTable from "../../../../Components/MUIDataTable/MUIDataTable";
import AddAssetModal from "./AddAssetModal";
import AddCategoryModal from "./AddCategoryModal";
import {
  getAllAssets,
  getAllAssetCategories,
} from "../../../../Redux/Actions/assetActions";
import { AiOutlinePlus } from "react-icons/ai";
import { BiReset } from "react-icons/bi";
import {FaEye, FaEdit } from "react-icons/fa";
import {FiSearch} from "react-icons/fi"
import { BsTrashFill } from "react-icons/bs";
import { MdAssignmentAdd } from "react-icons/md";
import IssueRecallAssetModal from "./IssueRecallAssetModal";
import UpdateAssetModal from "./UpdateAssetModal";
import api from "../../../../Utils/interceptors";
import { successNotify, errorNotify } from "../../../../Utils/toast";
import SiteModal from "../../../../Components/SiteModal/SiteModal";
import AutoCompleteSearch from "../../../../Components/AutoCompleteSearch/AutoCompleteSearch";

const AssetsList = () => {
  // Redux and state hooks
  const dispatch = useDispatch();
  const [openAssetModal, setOpenAssetModal] = useState(false);
  const [openCategoryModal, setOpenCategoryModal] = useState(false);
  const [openIssueRecallModal, setOpenIssueRecallModal] = useState(false);
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [selectedAssetId, setSelectedAssetId] = useState(null);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [isRecall, setIsRecall] = useState(false);
  const [employeeId, setEmployeeId] = useState("");
  const [notes, setNotes] = useState("");
  const [filterCategory, setFilterCategory] = useState("");
  const [filterBrand, setFilterBrand] = useState("");
  const [filterModel, setFilterModel] = useState("");
  const [filterCondition, setFilterCondition] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [filterTag, setFilterTag] = useState("");
  const [filterEmployee, setFilterEmployee] = useState("");
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [currentFilters, setCurrentFilters] = useState({
    tag: "",
    category: "",
    brand: "",
    model: "",
    condition: "",
    status: "",
    employee: "",
    search: ""
  });
  const [categoryCreated, setCategoryCreated] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteAssetId, setSelectedDeleteAssetId] = useState(null);
  
  const assets = useSelector((state) => state.asset.assets);
  const assetsCount = useSelector((state) => state.asset.assetsCount);
  const categories = useSelector((state) => state.asset.categories);
  const categoriesLoading = useSelector(
    (state) => state.asset.categoriesLoading
  );
  const employeesState = useSelector((state) => state.employees);
  // Robustly extract an array of employee objects from several possible reducer shapes
  const employeesList = (() => {
    if (!employeesState) return [];
    if (Array.isArray(employeesState)) return employeesState;
    if (Array.isArray(employeesState.employees)) return employeesState.employees;
    if (
      employeesState.employees &&
      typeof employeesState.employees === "object" &&
      Array.isArray(employeesState.employees.employees)
    )
      return employeesState.employees.employees;
    // fallback: find first array value in the object
    const arr = Object.values(employeesState).find((v) => Array.isArray(v));
    return Array.isArray(arr) ? arr : [];
  })();
  
  useEffect(() => {
    dispatch(getAllAssetCategories());
  }, [dispatch, categoryCreated]);

  useEffect(() => {
    if (categoryCreated) {
      dispatch(
        getAllAssets({
          ...currentFilters,
          page,
          size,
        })
      );
    } else {
      dispatch(getAllAssets({page, size}));
    }
  }, [dispatch, currentFilters, page, size, categoryCreated]);

  useEffect(() => {
    if (categoryCreated) {
      setCategoryCreated(false);
    }
  }, [categoryCreated]);

  // Asset columns for MuiDataTable
  const assetColumns = [
    {
      name: "_id",
      options: { display: false },
    },
    {
      name: "tag",
      label: "Tag",
      options: {
        setCellProps: () => ({
          style: {
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
          },
        }),
        setCellHeaderProps: () => ({ style: { textAlign: "center" } }),
        customBodyRender: (value) => (
          <span
            className="fs-12"
            style={{
              display: "inline-block",
              width: "100%",
              textAlign: "center",
            }}
          >
            {value || "-"}
          </span>
        ),
      },
    },
    {
      name: "category",
      label: "Category",
      options: {
        setCellProps: () => ({
          style: {
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
          },
        }),
        setCellHeaderProps: () => ({ style: { textAlign: "center" } }),
        customBodyRender: (value) => {
          const categoryName = value?.name || "-";
          const capitalized = categoryName
            .split(" ")
            .map((w) =>
              w.length ? w[0].toUpperCase() + w.slice(1).toLowerCase() : ""
            )
            .join(" ");
          return (
            <span
              className="fs-12"
              style={{
                display: "inline-block",
                width: "100%",
                textAlign: "center",
              }}
            >
              {capitalized}
            </span>
          );
        },
      },
    },
    {
      name: "brand",
      label: "Brand",
      options: {
        customBodyRender: (value) => (
          <span className="fs-12">{value || "-"}</span>
        ),
      },
    },
    {
      name: "model",
      label: "Model",
      options: {
        customBodyRender: (value) => (
          <span className="fs-12">{value || "-"}</span>
        ),
      },
    },
    {
      name: "availibility_status",
      label: "Status",
      options: {
        customBodyRender: (value) => {
          const status = value || "-";
          const capitalized = status
            .split(" ")
            .map((w) =>
              w.length ? w[0].toUpperCase() + w.slice(1).toLowerCase() : ""
            )
            .join(" ");
          return <span className="fs-12">{capitalized}</span>;
        },
      },
    },
    {
      name: "issued_to",
      label: "Issued To",
      options: {
        customBodyRender: (value) => (
          <span className="fs-12">{value?.full_name || "-"}</span>
        ),
      },
    },
    {
      name: "action",
      label: "Action",
      options: {
        customBodyRender: (value, tableMeta) => {
          const assetId = tableMeta.rowData[0];
          const asset = assets.find((a) => a._id === assetId);
          const handleIssueRecallClick = () => {
            const recalling = asset.issued_to != null;
            setIsRecall(recalling);
            // If recalling, prefill employeeId with the employee who currently has the asset
            if (recalling) {
              setEmployeeId(asset.issued_to?._id || "");
            } else {
              // issuing: clear any previously selected employee
              setEmployeeId("");
            }
            setSelectedAssetId(assetId);
            setOpenIssueRecallModal(true);
          };

          const handleUpdateClick = () => {
            setSelectedAsset(asset);
            setOpenUpdateModal(true);
          };

          const handleDeleteClick = () => {
            setSelectedDeleteAssetId(assetId);
            setShowDeleteModal(true);
          };

          return (
            <div className="leaves_management_btn_container">
              <button
                className="edit_btn"
                onClick={() =>
                  (window.location.href = `/employee/assets/${assetId}`)
                }
              >
                <FaEye />
              </button>
              <button
                className="edit_btn"
                onClick={handleIssueRecallClick}
              >
                <MdAssignmentAdd />
              </button>
              <button
                className="edit_btn"
                onClick={handleUpdateClick}
              >
                <FaEdit />
              </button>
              <button
                className="delete_btn"
                onClick={handleDeleteClick}
              >
                <BsTrashFill />
              </button>
            </div>
          );
        },
      },
    },
  ];

  const handleSearch = () => {
    const newFilters = {
      tag: filterTag,
      category: filterCategory,
      brand: filterBrand,
      model: filterModel,
      condition: filterCondition,
      status: filterStatus,
      employee: filterEmployee,
      search: searchText
    };
    setCurrentFilters(newFilters);
    setPage(0);
    dispatch(getAllAssets({
      ...newFilters,
      page: 0,
      size,
    }));
  };

  const clearFilters = () => {
    setFilterTag("");
    setFilterCategory("");
    setFilterBrand("");
    setFilterModel("");
    setFilterCondition("");
    setFilterStatus("");
    setFilterEmployee("");
    setSearchText("");
    setPage(0);
    // Apply the cleared filters immediately
    setCurrentFilters({
      tag: "",
      category: "",
      brand: "",
      model: "",
      condition: "",
      status: "",
      employee: "",
      search: ""
    });
    dispatch(getAllAssets({
      tag: "",
      category: "",
      brand: "",
      model: "",
      condition: "",
      status: "",
      employee: "",
      page: 0,
      size,
      search: "",
    }));
  };

  const handleConfirmDelete = async () => {
    try {
      const response = await api.delete(`/asset/${selectedDeleteAssetId}`);
      if (response.status === 200) {
        successNotify("Asset deleted successfully");
        setShowDeleteModal(false);
        // Refresh the assets list
        dispatch(getAllAssets({
          category: filterCategory,
          brand: filterBrand,
          model: filterModel,
          condition: filterCondition,
          status: filterStatus,
          page,
          size,
          search: searchText,
        }));
      }
    } catch (error) {
      errorNotify(
        error.response?.data?.message ||
        error.message ||
        "Error deleting asset"
      );
    }
  };

  const handleSubmit = useCallback(async () => {
    try {
      const apiUrl = isRecall
        ? `/asset/${selectedAssetId}/recall`
        : `/asset/${selectedAssetId}/issue`;

      const response = await api.post(apiUrl, {
        employeeId,
        notes,
      });

      if (response.status === 200) {
        successNotify(response.data.message);
        setOpenIssueRecallModal(false);
        // clear local fields
        setEmployeeId("");
        setNotes("");
        dispatch(getAllAssets({
          category: filterCategory,
          brand: filterBrand,
          model: filterModel,
          condition: filterCondition,
          status: filterStatus,
          page,
          size,
          search: searchText,
        }));
      } else {
        errorNotify("Something went wrong");
      }
    } catch (error) {
      errorNotify(
        error.response?.data?.message ||
        error.message ||
        "Something went wrong"
      );
    }
  },[isRecall, selectedAssetId, employeeId, notes, filterCategory, filterBrand, filterModel, filterCondition, filterStatus, page, size, searchText, dispatch]);

  return (
    <>
      <div className="page_responsive">
        <Header title="Assets" />
        <MetaData title="Assets" />
        <Container fluid>
          <Row className="m-0">
            <Col md={12}>
              <div className="employees_main_selection">
                <Form>
                  <Row className="align-items-center" style={{rowGap: "20px"}}>
                    <Col md={2}>
                      <Form.Group controlId="filterTag">
                        <Form.Label>Tag</Form.Label>
                        <Form.Control
                          type="text"
                          value={filterTag}
                          onChange={(e) => setFilterTag(e.target.value)}
                          placeholder="Asset Tag"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group controlId="filterCategory">
                        <Form.Label>Category</Form.Label>
                        <Form.Select
                          value={filterCategory}
                          onChange={(e) => setFilterCategory(e.target.value)}
                         >
                          <option value="">All</option>
                          {categories &&
                            categories.map((cat) => (
                              <option key={cat._id} value={cat._id}>
                                {cat.name.charAt(0).toUpperCase() +
                                  cat.name.slice(1)}
                              </option>
                            ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group controlId="filterBrand">
                        <Form.Label>Brand</Form.Label>
                        <Form.Control
                          type="text"
                          value={filterBrand}
                          onChange={(e) => setFilterBrand(e.target.value)}
                          placeholder="Brand"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group controlId="filterModel">
                        <Form.Label>Model</Form.Label>
                        <Form.Control
                          type="text"
                          value={filterModel}
                          onChange={(e) => setFilterModel(e.target.value)}
                          placeholder="Model"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group controlId="filterCondition">
                        <Form.Label>Condition</Form.Label>
                        <Form.Select
                          value={filterCondition}
                          onChange={(e) => setFilterCondition(e.target.value)}
                         >
                          <option value="">All</option>
                          <option value="new">New</option>
                          <option value="used">Used</option>
                          <option value="damaged">Damaged</option>
                          <option value="repaired">Repaired</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group controlId="filterStatus">
                        <Form.Label>Status</Form.Label>
                        <Form.Select
                          value={filterStatus}
                          onChange={(e) => setFilterStatus(e.target.value)}
                          >
                          <option value="">All</option>
                          <option value="in stock">In Stock</option>
                          <option value="issued">Issued</option>
                          <option value="under maintenance">
                            Under Maintenance
                          </option>
                          <option value="lost">Lost</option>
                          <option value="scrapped">Scrapped</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group controlId="filterEmployee">
                        <Form.Label>Employee</Form.Label>
                        <AutoCompleteSearch
                          data={employeesList}
                          departmentData={filterEmployee}
                          setDepartmentData={setFilterEmployee}
                          title={"Search Employee..."}
                        />
                      </Form.Group>
                    </Col>
                    <Col
                      md={8}
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "flex-end",
                        alignSelf: "flex-end",
                        gap: "10px"
                      }}
                    >
                      <button
                        type="button"
                        onClick={handleSearch}
                        style={{
                          padding: "10px 20px",
                          background: "linear-gradient(to bottom, #0097d9, #00b1ff)",
                          boxShadow: "0 15px 20px 0 rgb(13 110 253 / 30%)",
                          border: "none",
                          width: "100%",
                          maxWidth: "100px",
                          fontSize: "12px",
                          fontWeight: 500,
                          borderRadius: "10px",
                          color: "white",
                          height: "42px",
                          display: "flex",
                          gap: "5px",
                          justifyContent: "center",
                          alignItems: "center"
                        }}
                      >
                        <FiSearch />
                        Search
                      </button>
                      <button
                        type="button"
                        onClick={clearFilters}
                        style={{
                          padding: "8px 15px",
                          background:
                            "linear-gradient(to bottom, #0097d9, #00b1ff)",
                          boxShadow: "0 15px 20px 0 rgb(13 110 253 / 30%)",
                          border: "none",
                          fontSize: "12px",
                          fontWeight: 500,
                          borderRadius: "10px",
                          color: "white",
                          height: "42px"
                        }}
                      >
                        <BiReset /> Reset
                      </button>
                      <button
                        type="button"
                        onClick={() => setOpenCategoryModal(true)}
                        style={{
                          padding: "8px 15px",
                          background:
                            "linear-gradient(to bottom, #0097d9, #00b1ff)",
                          boxShadow: "0 15px 20px 0 rgb(13 110 253 / 30%)",
                          border: "none",
                          fontSize: "12px",
                          fontWeight: 500,
                          borderRadius: "10px",
                          color: "white",
                          height: "42px"
                        }}
                      >
                        <AiOutlinePlus /> Add Category
                      </button>
                      <button
                        type="button"
                        onClick={() => setOpenAssetModal(true)}
                        style={{
                          padding: "8px 15px",
                          background: "#ee1c25",
                          boxShadow: "0 15px 20px 0 rgb(13 110 253 / 30%)",
                          border: "none",
                          fontSize: "12px",
                          fontWeight: 500,
                          borderRadius: "10px",
                          color: "white",
                          height: "42px"
                        }}
                      >
                        <AiOutlinePlus /> Add Asset
                      </button>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
            <Col md={12}>
              <div className="tickets_management_table mt-3">
                <MuiDataTable
                  title={"ALL ASSETS"}
                  columns={assetColumns}
                  data={assets || []}
                  page={page}
                  setPage={setPage}
                  rowsPerPage={size}
                  setRowsPerPage={setSize}
                  count={assetsCount || 0}
                  text={searchText}
                  setText={setSearchText}
                  tableId="employee_assets_table"
                />
              </div>
            </Col>
          </Row>
        </Container>
        <IssueRecallAssetModal
          open={openIssueRecallModal}
          onClose={() => setOpenIssueRecallModal(false)}
          assetId={selectedAssetId}
          isRecall={isRecall}
          employeesList={employeesList}
          employeeId={employeeId}
          onSubmit={handleSubmit}
          setEmployeeId={setEmployeeId}
          setNotes={setNotes}
        />
        <AddAssetModal
          open={openAssetModal}
          onClose={() => setOpenAssetModal(false)}
          categories={categories}
          categoriesLoading={categoriesLoading}
          onAssetCreated={() => {
            dispatch(getAllAssets({
              category: filterCategory,
              brand: filterBrand,
              model: filterModel,
              condition: filterCondition,
              status: filterStatus,
              page,
              size,
              search: searchText,
            }));
          }}
        />
        <AddCategoryModal
          open={openCategoryModal}
          onClose={() => setOpenCategoryModal(false)}
          categories={categories}
          categoriesLoading={categoriesLoading}
          onCategoryCreated={() => setCategoryCreated(true)}
        />
        <UpdateAssetModal
          open={openUpdateModal}
          onClose={() => {
            setOpenUpdateModal(false);
            setSelectedAsset(null);
          }}
          asset={selectedAsset}
          categories={categories}
          employeesList={employeesList}
          onAssetUpdated={() => {
            dispatch(getAllAssets({
              category: filterCategory,
              brand: filterBrand,
              model: filterModel,
              condition: filterCondition,
              status: filterStatus,
              page,
              size,
              search: searchText,
            }));
          }}
        />
        <SiteModal
          title="Delete Asset"
          show={showDeleteModal}
          onCloseModal={() => setShowDeleteModal(false)}
        >
          <React.Fragment>
            <p className="modal_Text">Are you sure you want to delete this asset?</p>
            <div className="modal_decision">
              <button className="my-1 bg_red" onClick={handleConfirmDelete}>
                Yes
              </button>
              <button className="my-1 no_btn" onClick={() => setShowDeleteModal(false)}>
                No
              </button>
            </div>
          </React.Fragment>
        </SiteModal>
      </div>
    </>
  );
};

export default AssetsList;
